<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Ingreso guía de recepción</h1>
      <b-row>
        <b-col cols="12">
          <b-card no-body>
            <form-wizard
              color="#0074d9"
              shape="circle"
              stepSize="sm"
              errorColor="#ff4136"
              ref="wizard"
              nextButtonText="Siguiente"
              backButtonText="Atrás"
              finishButtonText="Finalizar"
              @on-complete="onComplete(waybillData.id)"
              title=""
              subtitle=""
            >
              <tab-content title="Información del documento" :before-change="submitWaybill">
                <b-row>
                  <b-col sm="12" md="6" lg="6">
                    <recepcion-form1 :waybillData="waybillData" ref="recepcionForm1" @validate="formStepVal1 = $event">
                    </recepcion-form1>
                  </b-col>
                  <b-col sm="12" md="6" lg="6">
                    <custom-fields
                      :form="waybillData.custom_fields"
                      :input_group="waybill_custom_fields"
                    ></custom-fields>
                  </b-col>
                </b-row>
              </tab-content>

              <tab-content title="Detalle de la guía (fruta)" :before-change="getWaybillData">
                <!-- v-bind: or just : to comunicate data from parent component to child component. In child must be prop exported. -->
                <b-row>
                  <b-col lg="12">
                    <modal-lote
                      :formModal="formModal"
                      v-bind:company="waybillData.company.value"
                      :client_customer="waybillData.client_customer.id"
                      v-bind:waybillID="waybillData.id"
                      v-bind:waybillDATE="waybillData.waybill_date"
                      @refreshContents="getContents($event)"
                      ref="modals"
                    >
                    </modal-lote>
                    <modal-contenido
                      :formModal="formModal"
                      v-bind:company="waybillData.company.value"
                      :client_customer="waybillData.client_customer"
                      v-bind:waybillID="waybillData.id"
                      v-bind:waybillDATE="waybillData.waybill_date"
                      @refreshContents="getContents($event)"
                      ref="modals"
                    >
                    </modal-contenido>

                    <br />
                    <c-table
                      :table-data="items"
                      :fields="fields"
                      :waybillID="waybillData.id"
                      small
                      caption="Detalle de guía de despacho"
                      @refreshContent="getContents($event)"
                    >
                    </c-table>
                  </b-col>
                </b-row>
              </tab-content>
              <tab-content title="Reporte">
                <report v-if="waybill" ref="report" :waybill="waybill"></report>
              </tab-content>
            </form-wizard>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// TODO: Cuando me dirijo a Ingreso desde editar guia, no refresca la pagina ingreso.
// TODO: El boton de NExt debe permanecer inactiva hasta qeu se rellenen los datos obligatorios.
// TODO: Pantalla de finalización del proceso con opcion de imprimir, enviar x correo, etc.
// TODO: Comportamiento de modales; a veces se quedan pegados.

import cTable from "./DetallesRecepcion.vue";
import recepcionForm1 from "./RecepcionForm1.vue";
import report from "./Report.vue";
import modalLote from "./ModalLote.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import miniToastr from "mini-toastr";
import modalContenido from "./ModalContenido";
import CustomFields from "./CustomFields.vue";
import { mapState } from "vuex";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "inicio",
  components: {
    CustomFields,
    modalContenido,
    cTable,
    modalLote,
    report,
    FormWizard,
    TabContent,
    recepcionForm1
  },
  mounted() {
    this.waybillSaved = false;
    if (this.waybillID != null) {
      this.loadWaybill(this.waybillID);
      this.waybillSaved = true;
    }
  },
  props: ["waybillID"],
  computed: {
    ...mapState({
      waybill_custom_fields: (state) => state.user.waybill_custom_fields
    })
  },
  data() {
    return {
      selected: [], // Must be an array reference!
      parent: "",
      waybillSaved: false,
      formModal: {
        status: false, //False to hide, True to show.
        type: false //False if is a new content, True if there is an axistind content and require edition.
      },
      show: true,
      validated: false,
      items: [],
      counter: 0,
      waybill: null,
      waybillData: {
        id: "",
        number: "",
        plant: "",
        waybill_date: "",
        arrival_datetime: "",
        internal_note: "",
        note: "",
        license_plate: "",
        truck_driver: "",
        company: "",
        recipient_company: "",
        client_customer: "",
        client: null,
        custom_fields: {}
      },
      companies: [],
      fields: [
        { key: "number", label: "Lote", sorteable: true },
        { key: "product_name", label: "Especie", sorteable: true },
        { key: "product_type_name", label: "Tipo", sorteable: true },
        { key: "variety_name", label: "Variedad", sorteable: true },
        { key: "condition", label: "Condición", sorteable: true },
        { key: "origin_name", label: "Huerto", sorteable: true },
        { key: "pallets", label: "Pallets", sorteable: true },
        // {key: 'pallet_number', label: 'Número', sorteable: true},
        // {key: 'product_name', label: 'Producto', sorteable: true},
        // {key: 'product_type_name', label: 'Tipo', sorteable: true},
        // {key: 'variety_name', label: 'Variedad', sorteable: true},
        // {key: 'origin_name', label: 'Origen', sorteable: true},
        // {key: 'condition', label: 'Condición', sorteable: true},
        // {key: 'container_name', label: 'Formato/Recip', sorteable: true},
        // {key: 'string_specs', label: 'Especificaciones', sorteable: true},
        // {key: 'quantity', label: 'Cantidad', sorteable: true},
        // {key: 'net_kilograms', label: 'Kg Netos', sorteable: true},
        // {key: 'status_content', label: 'Estatus', sorteable: true},
        // {key: 'actions', label: ' ', sorteable: true},
        { key: "actions", label: "", sorteable: true }
      ],
      formStepVal1: false
    };
  },
  methods: {
    getCompleteWaybill(a) {
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    loadWaybill(a) {
      this.$axios
        .get("/api/v1/waybill/" + a + "/")
        .then((res) => {
          this.waybillData.id = res.data.id;
          this.waybillData.number = res.data.number;
          this.waybillData.waybill_date = res.data.waybill_date;
          // this.waybillData.arrival_datetime = res.data.arrival_datetime;
          this.waybillData.internal_note = res.data.internal_note;
          this.waybillData.note = res.data.note;
          this.waybillData.plant = res.data.plant;
          this.waybillData.license_plate = res.data.license_plate;
          this.waybillData.truck_driver = res.data.truck_driver;
          this.waybillData.custom_fields = res.data.custom_fields;

          this.waybillData.client_customer = res.data.client_customer;
          this.getCompanies(res.data.client_customer);
          const objCompany = {
            text: res.data.company_number + " - " + res.data.company_name,
            value: res.data.company
          };

          this.waybillData.company = objCompany;

          //this.getCompanies(res.data.client_customer);

          this.getCompanyRelations(res.data.company);
          this.waybillData.client = res.data.client;
        })
        .catch((error) => console.log(error));
    },
    getWaybillData() {
      if (this.items && this.items.length) {
        this.getCompleteWaybill(this.waybillData.id);
        return true;
      } else {
        this.$swal.fire("Debe agregar por lo menos un contenido en la guia", "", "warning");

        return false;
      }
    },
    getCompanies(a) {
      this.companies = [{ value: null, text: "Cargando..." }];
      this.$axios
        .get("/production/get_companies/" + a + "/")
        .then((res) => {
          const data = res.data.data;
          const companies = [];
          for (let key in data) {
            const company = data[key];
            companies.push(company);
          }
          this.companies = companies;
        })
        .catch((error) => console.log(errors));
    },
    // To call origins and plants related to the company selected
    getCompanyRelations(a) {
      this.$refs.modals.getCompanyFacilities(a);
    },
    getContents(a) {
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_lots/")
        .then((res) => {
          this.items = res.data;
        })
        .catch((error) => console.log(error));
    },
    changeVerification: async () => {
      const formData = {
        number: parent.waybillData.number,
        waybill_date: parent.waybillData.waybill_date,
        waybill_type: 0, // Si es recepción, 1 si es despacho.
        // arrival_datetime: this.waybillData.arrival_datetime,
        internal_note: parent.waybillData.internal_note,
        note: parent.waybillData.note,
        license_plate: parent.waybillData.license_plate,
        truck_driver: parent.waybillData.truck_driver,
        plant: parent.waybillData.plant,
        company: parent.waybillData.company.value,
        client_customer: parent.waybillData.client_customer,
        client: parent.$store.getters.user.ID_CLIENTE,
        custom_fields: parent.waybillData.custom_fields
      };

      if (parent.waybillSaved === false) {
        try {
          const res = await parent.$axios
            .post("/api/v1/waybill/", formData)
            .then((res) => {
              miniToastr.success("Guía creada con éxito", "");
              parent.waybillData.id = res.data.id;
              parent.waybillSaved = true;
              parent.validated = true;
              parent.getContents(res.data.id);
            })
            .catch(function (error) {
              parent.$swal.fire(error.response.data.non_field_errors[0], "", "warning");
              parent.validated = false;
            });
        } catch (err) {
          console.error("erroor" + err);
        }
      } else {
        try {
          const res = await parent.$axios
            .put("/api/v1/waybill/" + parent.waybillData.id + "/", formData)
            .then((res) => {
              miniToastr.success("Guía actualizada con éxito", "");
              parent.waybillData.id = res.data.id;
              parent.validated = true;
              parent.getContents(res.data.id);
            })
            .catch(function (error) {
              parent.$swal.fire(error.response.data.non_field_errors[0], "", "warning");
              parent.validated = false;
            });
        } catch (err) {
          console.error("erroor" + err);
        }
      }

      return parent.validated;
    },
    submitWaybill() {
      this.$refs.recepcionForm1.submit();
      parent = this;
      if (this.formStepVal1 === true) {
        return this.changeVerification();
      } else {
        return false;
      }
    },
    onComplete(a) {
      // Sweet alert with final notes input
      this.$swal.fire({
        title: "¿Desea completar la guía?",
        text: "Ingrese las notas finales",
        input: "textarea",
        inputValue: this.waybillData.note,
        inputPlaceholder: "Notas finales",
        inputAttributes: {
          "aria-label": "Type your message here"
        },
        showCancelButton: true,
        confirmButtonText: "Completar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          this.waybillData.note = login;
          this.$axios
            .put("/api/v1/waybill/" + a + "/close_waybill/", {
              note: this.waybillData.note
            })
            .then((res) => {
              this.$swal.fire("Guía completada con éxito", "", "success");
              this.$router.push("/recepcion/listado");
            })
            .catch((error) => console.log(error));
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      });

      // this.$axios
      //   .put("/api/v1/waybill/" + a + "/close_waybill/", payload)
      //   .then((res) => {
      //     this.$router.push("/recepcion/listado");
      //   })
      //   .catch((error) => console.log(error));
    }
  },
  beforeMount() {}
};
</script>

<style scoped>
>>.wizard-header {
  padding: 0px;
}
</style>
